import { WOHNEN_UPSELL } from '@/pages/tenant/components/WohnenUpsellModal/wohnenUpsell.config';
import useOptimizelyExperimentVariation from '@/optimizely/useOptimizelyExperimentVariation';
import { campaigns } from '@/components/common/campaigns';

export const useWohnenPlusUpsellContentExperimentConfig = () => {
  const isVariation1 = useOptimizelyExperimentVariation('upsell_modal_price_decrease_experiment', 'variation1');
  const configurationIds = isVariation1
    ? WOHNEN_UPSELL.CONFIGURATION_IDS.DISCOUNTED_EXPERIMENTAL
    : WOHNEN_UPSELL.CONFIGURATION_IDS.DISCOUNTED;
  const upsellConfig = isVariation1
    ? WOHNEN_UPSELL.CONFIGURATION_IDS.UPSELL.EXPERIMENTAL_DISCOUNT
    : WOHNEN_UPSELL.CONFIGURATION_IDS.UPSELL.DISCOUNT;
  const campaignUrls = isVariation1
    ? campaigns.MEIN_PLUS_WP_UPSELL_MODAL.DISCOUNTED_EXPERIMENTAL
    : campaigns.MEIN_PLUS_WP_UPSELL_MODAL.DISCOUNTED;
  return {
    configurationIds,
    upsellConfig,
    campaignUrls,
  };
};

export default useWohnenPlusUpsellContentExperimentConfig;
